import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    //RCTI PAGE VALUES
    selected: [],
    rctis: [],
    loading: false,
    dates: [],
    filterBy: "",
    filterCol: ""
    // defaultHeaders: [
    //     'id',
    //     'date',
    //     'externalRef',
    //     'project.name',
    //     'contractor.name',
    //     'total',
    //     'siteWeightTotal',
    //     'trips',
    //     'status',
    //     'user.email'
    // ],
  },
  mutations: Mutations,
  actions: {
  },
  getters: {
  }
}